import React from 'react';
import Image, { ImageProps, ImageLoaderProps } from 'next/image';

import { SvgWrapper, StyledObject } from './styles';

export interface GlImageProps extends ImageProps {
  sysId?: string;
  heroImage?: boolean;
  contentType?: string | null;
}

const imageLoader = ({ src }: ImageLoaderProps) => `https:${src}?fm=webp`;

export function GlImage({
  src,
  sysId,
  contentType,
  heroImage,
  className,
  loading = process.env.NEXT_PUBLIC_ENVIRONMENT === 'percy' ? 'eager' : 'lazy',
  layout = 'responsive',
  style,
  ...props
}: GlImageProps) {
  if (!src) return null;

  if (heroImage) {
    return (
      <Image
        {...props}
        src={src}
        loader={imageLoader}
        className={className}
        priority={true}
        layout={layout}
        style={{ zIndex: 0, ...style }}
        data-testid="gl-hero-img"
        data-cfid={sysId}
      />
    );
  }

  switch (contentType) {
    case src && 'image/svg+xml':
      return (
        <SvgWrapper>
          <StyledObject
            className={className}
            data={src as string}
            type={contentType}
            data-script-order={0}
            data-testid="svg-image-type"
            data-cfid={sysId}
          >
            <Image
              {...props}
              src={src}
              loader={imageLoader}
              className={className}
              loading={loading}
              layout={layout}
              style={style}
              data-testid="gl-img"
              data-cfid={sysId}
            />
          </StyledObject>
        </SvgWrapper>
      );

    case 'image/gif':
      return (
        <Image
          {...props}
          src={src}
          loader={imageLoader}
          className={className}
          loading={loading}
          layout={layout}
          style={{ width: '100%', ...style }}
          data-testid="gl-img"
          data-cfid={sysId}
        />
      );

    case 'image/jpeg':
    case 'image/png':
    default:
      return (
        <Image
          {...props}
          src={src}
          loader={imageLoader}
          className={className}
          loading={loading}
          layout={layout}
          style={style}
          data-testid="gl-img"
          data-cfid={sysId}
        />
      );
  }
}

export default GlImage;
